<template>
  <div class="csqbox">
    <h2 class="header">灵活就业人员基本养老保险缴费测算器</h2>
    <div class="itembox">
      <div class="item">
        <label>您的年缴费金额为：</label>
        <span>{{ yearMoney }}元</span>
      </div>
      <div class="item">
        <label>您的月缴费金额为：</label>
        <span>{{ monthMoney }}元</span>
      </div>
    </div>
    <h3>参数设置</h3>
    <div class="itembox">
      <div class="item" style="padding: 0.1rem 0;">
        <label>上一年度黑龙江省社平工资：</label>
        <span>84120元<p>(2023年社平工资)</p></span>
      </div>
      <div class="item">
        <label>缴费费率：</label>
        <span>20%</span>
      </div>
      <div class="item">
        <label>分档比例：</label>
        <span @click="show=true">{{ value }}</span>
      </div>
    </div>
    <p class="tips">温馨提示：</p>
    <p class="tips">年缴费金额 = 上一年度黑龙江省社平工资 × 缴费费率 × 分档比例</p>
    <p class="tips">月缴费金额 = 年缴费金额 ÷ 12</p>
    <p class="tips">计算结果仅供参考，精确金额以实际缴纳为准</p>
    <button class="jsbtn" @click="count">计算</button>
    <van-popup position="bottom" v-model="show">
      <van-picker
        title="选择分档比例"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="show=false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data(){
    return{
      show:false,
      columns: ['60%', '70%', '80%', '90%', '100%', '150%', '200%', '250%', '300%'],
      columnsValue: [0.6, 0.7, 0.8, 0.9, 1, 1.5, 2, 2.5, 3],
      value:"请选择",
      yearMoney:"",
      monthMoney:"",
      currentValue:"",
    }
  },
  methods:{
    onConfirm(value, index) {
      this.value = value
      this.currentValue = this.columnsValue[index]
      this.show = false
    },
    count(){
      if(this.value=="请选择"){
        this.$toast("请选择分档比例")
        return
      }
      this.yearMoney = (84120 * 0.2 * this.currentValue).toFixed(2)
      this.monthMoney = (this.yearMoney/12).toFixed(2)
    },
  }
}
</script>

<style scoped>
.csqbox{
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #f0eff4;
  
}
.header{
  background-color: #34bff6;
  line-height: 0.82rem;
  color: #fff;
  text-align: center;
  font-size: 0.3rem;
  box-shadow: 0 0 5px 5px rgba(0,0,0,.1);
}
.itembox{
  background-color: #fff;
  border-bottom: 1px solid #d2d1d7;
  border-top: 1px solid #d2d1d7;
}
.item{
  height: 0.8rem;
  display: flex;
  margin: 0 0.3rem;
  font-size: 0.3rem;
  align-items: center;
  justify-content: space-between;
  line-height: 1.2;
}
.item+.item{
  border-top: 1px solid #d2d1d7;
}
.item span{
  flex: 1;
  text-align: right;
}
h3{
  color: #7c7b80;
  text-align: left;
  padding: 0.3rem 0.3rem 0.16rem;
  font-weight: normal;
}
.jsbtn{
  width: 3rem;
  height: 0.62rem;
  background-color: #007aff;
  color: #fff;
  font-size: 0.24rem;
  border: none;
  border-radius: 0.05rem;
  margin-top: 0.57rem;
}
.tips{
  font-size: 0.24rem;
  text-align: left;
  padding: 0.2rem 0.3rem 0;
  color: #999;
}
</style>